<template>
  <v-layout align-center justify-center class="font-weight-light">
    <v-flex xs12 sm8 md4>
      <alert-bar></alert-bar>
      <v-card class="elevation-12 text-xs-center">
        <v-card-text>
          <v-form>
            <!-- <v-text-field v-model="user.email" prepend-icon="person" name="login" label="Email" type="text"></v-text-field> -->
            <v-text-field v-model="user.identification" return-masked-value mask="###.###.###-##" prepend-icon="person" name="login" label="CPF"  type="text"></v-text-field>
            <v-text-field v-model="user.password" id="password" prepend-icon="lock" name="password" label="Senha" type="password"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn block round large @click="login" color="primary" class="elevation-0 font-weight-light">ENTRAR</v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-layout row justify-center>
            <v-tooltip bottom="">
              <a @click="recoveryModel = true;" slot="activator">Recuperar senha</a>
              <span>Gerar uma nova chave de acesso provisória</span>
            </v-tooltip>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>


    <!-- DIALOG DE RECUPERAÇÃO DE SENHA -->
    <v-dialog v-model="recoveryModel" max-width="500">

      <v-card class="recovery">

        <v-card-title>
          <span class="headline">Recuperar Senha</span>
        </v-card-title>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field v-model="user.name" label="Nome *"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="user.email" label="E-mail *"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="user.cpf" label="Username *"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-text class="text-xs-center">
          <v-tooltip bottom>
            <v-btn slot="activator" color="primary" dark large @click="dialogConfirmNewKey = true; recoveryModel = false;">
              Gerar Chave
              <v-icon class="ml-3">vpn_key</v-icon>
            </v-btn>
            <span>Gerar chave de acesso provisória</span>
          </v-tooltip>
        </v-card-text>

        <div class="text-xs-center mt-4">
          <span class="blue--text">Os campos marcados com o (*) são obrigatórios</span><br><br>
        </div>

        <v-footer class="pa-3 mb-3" height="auto" color="info">
          <span class="white--text">
            <strong>AVISO:</strong>
            após preencher os campos e clickar no botão de Gerar Chave, será criada uma chave de acesso provisória que
            deve ser usada para acessar o sistema e ser alterada logo em seguida.
          </span>
        </v-footer>
      </v-card>
    </v-dialog>


    <!-- DIALOG DE COMFIRMAÇÃO DE CRIAÇÃO DA CHAVE DE ACESSO -->
    <v-dialog v-model="dialogConfirmNewKey" max-width="400" persistent>
      <v-card class="recovery">

        <v-card-title class="headline" primary-title>
          Confirmar dados
        </v-card-title>

        <v-card-text>
          <span>
            <strong>Nome:</strong> {{ user.name }}
            <br>
            <strong>Username:</strong> {{ user.username }}
            <br>
            <strong>E-mail:</strong> {{ user.email }}
          </span>
        </v-card-text>

        <v-card-text>
          <span>
            <strong>Confirma a geração da chave de acesso para os dados acima informados ?</strong>
          </span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="text-xs-center">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogLoading = true;">
            Sim
          </v-btn>
          <v-btn color="error" flat @click="dialogConfirmNewKey = false">
            Não
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- DIALOG DE LOADING -->
    <v-dialog v-model="dialogLoading" persistent width="500">
      <v-card color="primary" dark>
        <v-card-text>
          {{ msgLoading }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- DIALOG DE MENSAGEM DE CRIAÇÃO DA CHAVE COM SUCESSO -->
    <v-dialog v-model="dialogSuccessNewKey" max-width="500">
      <v-card class="recovery font-weight-light">
        <p><span><strong>A chave foi gerada com sucesso</strong></span></p>
        <p><span><strong>Por favor acesse o e-mail para visualizar e acessar com o seu Username</strong></span></p>
        <v-divider></v-divider>
        <v-btn flat icon color="primary" @click="dialogSuccessNewKey = false;">
          <v-icon>thumb_up</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>


    <!-- DIALOG DE ALTERAÇÃO DE SENHA -->
    <v-dialog v-model="updatePassModel" max-width="500">

      <v-card class="recovery">
        <v-toolbar color="white" class="elevation-3">
          <v-toolbar-items>
            <v-btn @click.stop.prevent="updatePassModel = false;" color="error" icon round flat>
              <v-icon color="error">remove</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-title class="headline font-weight-light">
            Criar senha
          </v-toolbar-title>
        </v-toolbar>

        <div @click="alert = false; msgAlert = '';">
          <v-alert v-model="alert" dismissible outline type="error">
            <span v-for="msg in msgAlert" :key="msg">{{ msg }} <br></span>
          </v-alert>
        </div>

        <v-card-text>
          <v-layout wrap class="font-weight-light">
            <v-flex xs12>
              <v-text-field v-model="user.username" label="Username *" disabled></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="user.key" label="Chave de acesso provisória *"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="user.password" label="Senha *" type="password"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="confirmPassword" label="Confirmar senha *" type="password"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <div class="text-xs-center mt-4">
          <span class="blue--text">Os campos marcados com o (*) são obrigatórios</span><br><br>
        </div>

        <v-footer class="pa-3 mb-3" height="auto" color="info">
          <span class="white--text">
            <strong>AVISO:</strong>
            após criada, a senha não poderá ser visualizada, sendo necessário gerar uma nova chave de acesso proviśoria
            e criar uma senha novamente.
          </span>
        </v-footer>

        <v-card-actions class="text-xs-center">
          <v-btn title="Criar a senha informada para o usuário" color="info" block round @click="editPass();">Criar
            senha</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import AlertBar from "@/components/AlertBar";
  import UserService from "@/service/UserService";

  export default {
    components: {
      AlertBar
    },

    data() {
      return {
        user: {},
        userEdit: {},
        recoveryModel: false,
        dialogConfirmNewKey: false,
        dialogLoading: false,
        dialogSuccessNewKey: false,
        msgLoading: "Validando dados, aguarde...",
        updatePassModel: false,
        confirmPassword: "",
        alert: false,
        msgAlert: [],
      };
    },

    methods: {
      async login() {
        try {
          let user = await UserService.authenticate(this.user);
          if (user._id) {
            await UserService.setUserInLocalStorage(user);
            this.$store.dispatch('loadLoggedUser')            
            location.reload(true);
          }
        } catch (errors) {
          this.$store.commit("showAlertError", errors);
        }
      },

      async editPass() {
        this.msgAlert = [];

        if (!this.user.username)
          this.msgAlert.push("O username deve ser informado");

        if (!this.user.key || this.user.key == "")
          this.msgAlert.push("A chave provisória deve ser informada");

        if (!this.user.password)
          this.msgAlert.push("A senha deve ser informada");

        if (!this.confirmPassword)
          this.msgAlert.push("A confirmação de senha deve ser informada");

        if (this.user.password && this.confirmPassword) {
          if (this.user.password != this.confirmPassword)
            this.msgAlert.push("A senha e a confirmação da senha são diferentes");
          else this.msgAlert = [];
        }

        if (this.msgAlert.length > 0) {
          this.alert = true;
        } else {
          this.msgAlert = [];
          this.alert = false;
          this.update();
        }
      },

      async update() {
        let u = await UserService.getUserByUsername(this.user);
        console.log(u);
      },
    },

    watch: {
      dialogLoading(val) {
        if (!val) return;

        setTimeout(() => {
          this.msgLoading = "Criando chave, aguarde...";
          setTimeout(() => {
            this.msgLoading = "Enviando e-mail, aguarde...";
            setTimeout(() => {
              this.dialogLoading = false;
              this.dialogConfirmNewKey = false;
              this.dialogSuccessNewKey = true;
            }, 2000);
          }, 2000);
        }, 2000);

        this.user = {};
      },
    }
  };

</script>

<style>
  .v-dialog {
    border-radius: 10px !important;
  }

</style>

<style scoped>
  .v-card {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    padding: 20px 40px;
  }

  .v-card.recovery {
    background-color: rgba(255, 255, 255, 1);
  }

  .v-card> :last-child:not(.v-btn):not(.v-chip) {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/FormLogin.vue